import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2b817b",
    },
    secondary: {
      main: "#2b817b",
    },
  },
  typography: {
    fontFamily: "outfit",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  //   components: {
  //     MuiFormLabel: {
  //       styleOverrides: {
  //         asterisk: {
  //           color: "#df0584",
  //           "&$error": {
  //             color: "#df0584",
  //           },
  //         },
  //       },
  //     },
  //   },
});
export default theme;
